import { Setor, Aviso } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';

export class AvisoSetor extends BaseResourceModel {
  constructor(
    public id?: number,
    public aviso?: Aviso,
    public setor?: Setor,
  ) {
    super();
  }

  static converteJson(json: any): AvisoSetor {
    return Object.assign(new AvisoSetor(), json);
  }
}


